import { render, staticRenderFns } from "./BouncesTable.vue?vue&type=template&id=25672733&"
import script from "./BouncesTable.vue?vue&type=script&lang=ts&"
export * from "./BouncesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable} from 'quasar'
component.options.components = Object.assign({QMarkupTable}, component.options.components || {})
